module.exports = __webpack_public_path__ + "img/cover_jeremy_1200x1600.98ebfc7a.jpg";